/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import jMoment from 'moment-jalaali'
import {message} from 'antd'
import Select from 'react-select'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import $ from 'jquery'
import REPORT_RETAIL from '../../Component/BaseComponent/REPORTRETAIL'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import FromToPicker from '../BaseComponent/FromToPicker'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import {Helmet} from 'react-helmet'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import {Popover} from 'antd'
import AutoComplete from '../BaseComponent/autocomplete'

class PreRecord extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      providerId: '',
      refTypeWarehouseId: null,
      loading: false,
      wareHousesname: [],
      docType: [],
      errorForm: '',
      showTable: false,
      listWareHouse: [],
      preRecordInfo: {},
      urlQuery: '',
      providers: [],
      providerValue: '',
      selectedOption: [],
      wareType: [],
      fromDate: '',
      toDate: '',
      modalDelete: false,
      fromManual: '',
      toManual: '',
      printInfo: [],
      printFrom: '',
      printTo: '',
      buttonClicked: false,
      pageNumber: 1,
      pageSize: 10,
      countAll: 0,
      sortBy: 'registerDate_desc',
      getSort: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شماره پیش سند',
          value: 'preWarehouseDocId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ ثبت',
          value: 'registerDate',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'تاریخ دستی سند',
          value: 'manualRegisterDate',
          sorted: false,
          direction: null,
          sortable: true
        },

        {
          name: 'ماهیت',
          value: 'input',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام کاربر ثبت کننده',
          value: 'operatorName',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'نام انبار',
          value: 'warehouseName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نوع انبار',
          value: 'typePrimaryName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'بین انباری',
          value: 'internal',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام انبار طرف',
          value: 'internal',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تامین کننده',
          value: 'providerId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ویرایش',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: '',
          value: 'providerName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'مشاهده',
          value: 'seen',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'حذف',
          value: 'delete',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      warehouseId: '',
      operators: [],
      operatorId: null,
      tablePageNumber: 1,
      tablePageSize: 10
    }
  }

  submitForm(e) {
    e.preventDefault()
  }

  get componentDidMount() {
    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_PRIMARYWAREHOUSE}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            wareType: response.data.object
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    // http
    //   .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {})
    //   .then((response) => {
    //     if (response.data.error == null) {
    //       var result = response.data.object;
    //       for (let i = 0; i < result.length; i++) {
    //         result[i]["value"] = result[i].providerId;
    //         result[i]["label"] = result[i].providerId + " - " + result[i].title;
    //       }

    //       this.setState({
    //         providers: response.data.object,
    //       });
    //     }
    //     // alert(JSON.stringify(response.data))
    //   })
    //   .catch((error) => {
    //     alert(JSON.stringify(error));
    //   });

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_WAREHOUSE}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].id
            result[i]['label'] = result[i].id + ' - ' + result[i].name + ' - ' + result[i].typePrimaryName
          }
          this.setState({
            wareHousesname: response.data.object
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })

    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_DOCUMENT}`, {})
      .then((response) => {
        this.setState({
          docType: response.data.object
        })
      })
      .catch((error) => {
        console.log(error)
      })
    this.getOperators()
  }

  getOperators = () => {
    return http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {})
      .then((res) => {
        if (res.data.error === null) {
          res.data.object.forEach((item) => {
            item.value = item.personId
            item.label = item.personId + ' - ' + item.name
          })
          this.setState({
            operators: res.data.object
          })
        }
      })
      .catch(() => {})
  }

  changeOperator = (operatorId) => {
    this.setState({
      operatorId
    })
  }

  getReport = (exportStatus) => {
    this.setState({
      loading: true
    })
    let filter = this.createFilter(exportStatus)
    http
      .get(`${WAREHOUSE.WAREHOUSE_REPORT_PREVIEW}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            tablePageNumber: this.state.pageNumber,
            tablePageSize: this.state.pageSize,
            listWareHouse: response.data.object.result,
            errorForm: '',
            lengthList: response.data.object.countAll,
            printFrom: this.state.fromDate == '' ? ' - ' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
            printTo: this.state.toDate == '' ? ' - ' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
            buttonClicked: true,
            loading: false
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            listWareHouse: [],
            lengthList: 0,
            loading: false
          })
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
        this.setState({
          loading: false
        })
      })
  }

  changeField(e) {
    const target = e.target
    const value = target.type == 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState({
      [name]: value,
      id: value
    })
  }

  onResultFetched(data) {
    this.setState({
      listWareHouse: data
    })
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})

    console.log(`Option selected:`, selectedOption)
  }

  changeWareHouseId = (warehouseId) => {
    this.setState({warehouseId})
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  handleChangeManualFromDate = (fromManual) => {
    this.setState({
      fromManual
    })
  }

  handleChangeManualToDate = (toManual) => {
    this.setState({
      toManual
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    let isInput = document.getElementById('isInput').value
    let isInternal = document.getElementById('isInternal').value
    let warehousename = this.state.warehouseId == null || this.state.warehouseId == '' ? '' : this.state.warehouseId.id
    let providerId = this.state.providerId
    let preDocId = document.getElementById('preRecordId').value.trim()
    let refFactorNo = document.getElementById('refFactorNo').value.trim()
    let typePrimary = document.getElementById('typePrimary').value
    let refType = document.getElementById('refType').value
    let refTypePrimaryWarehouseId = document.getElementById('refTypePrimaryWarehouseId').value

    let operatorId = this.state.operatorId === null ? '' : this.state.operatorId.personId
    let manualRegisterDateMin = this.state.fromManual
    let manualRegisterDateMax = this.state.toManual
    let refTypeWarehouseId = this.state.refTypeWarehouseId === null ? '' : this.state.refTypeWarehouseId.id

    let registerDateMin = this.state.fromDate
    let registerDateMax = this.state.toDate
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (isInput !== '' && isInput.length) {
      filter.isInput = isInput
    }

    if (isInternal !== '' && isInternal.length) {
      filter.isInternal = isInternal
    }

    if (warehousename !== '') {
      filter.typeWarehouseId = warehousename
    }
    if (refTypeWarehouseId !== '') {
      filter.refTypeWarehouseId = refTypeWarehouseId
    }
    if (providerId !== '') {
      filter.providerId = providerId
    }
    if (operatorId !== '') {
      filter.operatorId = operatorId
    }
    if (preDocId !== '' && preDocId.length) {
      filter.preWarehouseDocId = preDocId
    }
    if (typePrimary !== '' && typePrimary.length) {
      filter.typePrimary = typePrimary
    }
    if (refTypePrimaryWarehouseId !== '') {
      filter.refTypePrimaryWarehouseId = refTypePrimaryWarehouseId
    }

    if (manualRegisterDateMin !== '') {
      filter.manualRegisterDateMin = manualRegisterDateMin
    }

    if (manualRegisterDateMax !== '') {
      filter.manualRegisterDateMax = manualRegisterDateMax
    }
    if (registerDateMin !== '') {
      filter.registerDateMin = registerDateMin
    }
    if (registerDateMax !== '') {
      filter.registerDateMax = registerDateMax
    }
    if (refFactorNo !== '') {
      filter.refFactorNo = refFactorNo
    }
    if (refType !== '') {
      filter.refType = refType
    }

    return filter
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
  }

  changeDropDown(data) {
    this.setState({
      listWareHouse: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  deletePreRecord = (num) => {
    sessionStorage.setItem('selectedRow', num)

    let preWarehouseDocId = this.state.listWareHouse[num].preWarehouseDocId
    sessionStorage.setItem('preWarehouseDocId', preWarehouseDocId)
    this.setState({
      modalDelete: !this.state.modalDelete
    })
  }

  deleteCancel = () => {
    this.setState({
      modalDelete: !this.state.modalDelete
    })
    sessionStorage.removeItem('preWarehouseDocId')
    sessionStorage.removeItem('selectedRow')
  }

  deleteOk = () => {
    var selectedRow = sessionStorage.getItem('selectedRow')

    let preWarehouseDocId = sessionStorage.getItem('preWarehouseDocId')
    let data = {
      docId: preWarehouseDocId
    }
    http
      .post(`${WAREHOUSE.WAREHOUSE_DOCUEMNT_DELETE_PREVIEW}`, data, {})
      .then((response) => {
        if (response.data.error == null && response.data.object == 'SUCCESS') {
          this.state.listWareHouse.splice(selectedRow, 1)
          this.setState(this.state.listWareHouse)

          message.success('پیش با موفقیت حذف شد')
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        } else {
          message.error(JSON.stringify('خطای ' + response.data.errorCode + ' : ' + response.data.description))
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })
    let filter = this.createFilter(true)

    http
      .get(`${WAREHOUSE.WAREHOUSE_REPORT_PREVIEW}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable,.print').fadeIn()

          this.setState({
            printInfo: response.data.object.result,
            lengthList: response.data.object.countAll,
            loading: false
          })
        } else {
          this.setState({
            printInfo: [],
            loading: false
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
        this.setState({
          loading: false
        })
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    let filter = this.createFilter(true)

    http
      .get(`${WAREHOUSE.WAREHOUSE_REPORT_PREVIEW}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['manualRegisterDate'] = jMoment(excelReport[i]['manualRegisterDate']).format('jYY/jMM/jDD')
            excelReport[i]['registerDate'] = jMoment(excelReport[i]['registerDate']).format('jYY/jMM/jDD')
            if (excelReport[i]['internal']) {
              excelReport[i]['internal'] = 'هست'
            } else {
              excelReport[i]['internal'] = 'نیست'
            }

            if (excelReport[i]['input']) {
              excelReport[i]['input'] = 'وارده'
            } else {
              excelReport[i]['input'] = 'صادره'
            }
          }
          this._export.save(this.state.excelReport)
        }
      })
  }

  randomNumber = () => {
    return Math.random()
  }

  render() {
    const {wareHousesname, selectedOption, loading} = this.state
    let {pageNumber, pageSize} = this.state
    var preWarehouseDocIdNum = sessionStorage.getItem('preWarehouseDocId')
    let name = cookie.load('name')
    let columns = [
      'ردیف',
      'شماره پیش سند',
      'تاریخ ثبت',
      'تاریخ دستی',
      'ماهیت',
      'نام کاربر ثبت',
      'انبار',
      'نوع انبار',
      'بین انباری',
      'نام انبار طرف',
      'تامین کننده'
    ]

    let excelColumns = [{title: 'نام سند', value: 'name'}, {title: 'نوع سند', value: 'in'}]

    return (
      <div className="rtl printA4Page">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{`پیش اسناد`}</title>
        </Helmet>
        <Loader show={loading} />

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش لیست پیش اسناد"
              headerColSpan={11}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={4}
              rightColSpan={3}
              centerColSpan={4}
              centerSection={''}
              rightSection={'تاریخ ثبت از ' + this.state.printFrom + ' تا ' + this.state.printTo}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((warehouse, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{warehouse.preWarehouseDocId}</td>
                  <td>{jMoment(warehouse.registerDate).format('jYYYY/jMM/jDD')}</td>
                  <td>
                    {warehouse.manualRegisterDate == null
                      ? '-'
                      : jMoment(warehouse.manualRegisterDate).format('jYYYY/jMM/jDD')}
                  </td>
                  <td>{warehouse.input ? 'وارده' : 'صادره'}</td>
                  <td>{warehouse.operatorName}</td>
                  <td>{warehouse.warehouseName}</td>
                  <td>{warehouse.typePrimaryName}</td>
                  <td>{warehouse.internal ? 'هست' : 'نیست'}</td>
                  <td>{warehouse.refTypeWarehouseName}</td>
                  <td>
                    <span>{warehouse.providerName == null ? '-' : warehouse.providerName}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            ref={(exporter) => {
              this._export = exporter
            }}
            dir="rtl"
            fileName="گزارش پیش اسناد.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'preWarehouseDocId'}
                field={'preWarehouseDocId'}
                title={'شماره پیش سند'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'registerDate'}
                field={'registerDate'}
                title={'تاریخ ثبت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'manualRegisterDate'}
                field={'manualRegisterDate'}
                title={'تاریخ ثبت دستی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'input'}
                field={'input'}
                title={'ماهیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'operatorName'}
                field={'operatorName'}
                title={'کاربر ثبت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'warehouseName'}
                field={'warehouseName'}
                title={'نام انبار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'typePrimaryName'}
                field={'typePrimaryName'}
                title={'نوع انبار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'internal'}
                field={'internal'}
                title={'بین انباری'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'refTypeWarehouseName'}
                field={'refTypeWarehouseName'}
                title={'نام انبار طرف'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'providerName'}
                field={'providerName'}
                title={'تامین کننده'}
                width="300px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'rowSum'}
                field={'rowSum'}
                title={'تعداد سطر'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'quantitySum'}
                field={'quantitySum'}
                title={'جمع مقدار'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>انبار</li>
            <li>لیست پیش سند ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid
                  getPageSize={this.getPageSize}
                  createLink={`/addPreRecord?id=${this.randomNumber()}`}
                  enablePageSize
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>شماره پیش سند : </label>
                  <input className="form-control" type="text" id="preRecordId" />
                </div>

                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ ثبت از"
                  toLabel="تاریخ ثبت تا"
                  fromId="from"
                  toId="to"
                />

                <FromToPicker
                  onChangeFromDate={this.handleChangeManualFromDate}
                  onChangeToDate={this.handleChangeManualToDate}
                  fromLabel="تاریخ دستی سند از"
                  toLabel="تاریخ دستی سند تا"
                  fromId="fromManual"
                  toId="toManual"
                />

                <div className="formComponent">
                  <label>نام انبار:</label>
                  <Select
                    value={this.state.warehouseId}
                    onChange={this.changeWareHouseId}
                    options={this.state.wareHousesname}
                    isClearable
                    placeholder="------"
                  />
                </div>
                <div className="formComponent">
                  <label>نام کاربر ثبت کننده:</label>
                  <Select
                    value={this.state.operatorId}
                    onChange={this.changeOperator}
                    options={this.state.operators}
                    isClearable
                    placeholder="------"
                  />
                </div>

                <div className="formComponent">
                  <label htmlFor="ماهیت">ماهیت</label>
                  <select className="custom-select" id="isInput" onChange={this.onChange} name="isInput" tabIndex="2">
                    <option value="">---------</option>
                    <option value="true">وارده</option>
                    <option value="false">صادره</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>نوع انبار : </label>
                  <select className="form-control" id="typePrimary" name="typePrimary">
                    <option value="">---------</option>
                    {this.state.wareType.map((wareType, index) => (
                      <option key={index} value={wareType.id}>
                        {wareType.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <label>سند بین انباری : </label>
                  <select className="form-control" id="isInternal">
                    <option value="">------</option>
                    <option value={1}>هست</option>
                    <option value={0}>نیست</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>نام انبار طرف:</label>
                  <Select
                    value={this.state.refTypeWarehouseId}
                    onChange={(refTypeWarehouseId) => this.setState({refTypeWarehouseId})}
                    options={this.state.wareHousesname}
                    isClearable
                    placeholder="------"
                  />
                </div>
                <div className="formComponent">
                  <label>نوع انبار طرف : </label>
                  <select className="form-control" id="refTypePrimaryWarehouseId" name="refTypePrimaryWarehouseId">
                    <option value="">---------</option>
                    {this.state.wareType.map((wareType, index) => (
                      <option key={index} value={wareType.id}>
                        {wareType.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <label>تامین کننده:</label>
                  <Select
                    value={selectedOption}
                    onChange={this.handleChange}
                    options={this.state.providers}
                    isMulti={false}
                    isClearable={true}
                    id="providerId"
                    placeholder=""
                  /> */}
                </div>
                <div className="formComponent">
                  <label>شماره فاکتور طرف : </label>
                  <input className="form-control" type="text" id="refFactorNo" />
                </div>

                <div className="formComponent">
                  <label>نوع طرف </label>
                  <select
                    className="form-control"
                    id="refType"
                    name="refType"
                    onChange={(e) => this.setState({refType: e.target.value})}
                  >
                    <option value="">---------</option>
                    <option value="CUSTOMER">مشتری</option>
                    <option value="PROVIDER">فروشنده</option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />

                  {this.state.listWareHouse.map((warehouse, index) => (
                    <tr key={index}>
                      <td>{(this.state.tablePageNumber - 1) * this.state.tablePageSize + index + 1}</td>
                      <td>{warehouse.preWarehouseDocId}</td>
                      <td>{jMoment(warehouse.registerDate).format('jYYYY/jMM/jDD HH:mm')}</td>
                      <td>
                        {warehouse.manualRegisterDate == null
                          ? '-'
                          : jMoment(warehouse.manualRegisterDate).format('jYYYY/jMM/jDD')}
                      </td>
                      <td>{warehouse.input ? 'وارده' : 'صادره'}</td>
                      <td>{warehouse.operatorName}</td>
                      <td>{warehouse.warehouseName}</td>
                      <td>{warehouse.typePrimaryName}</td>
                      <td>
                        {warehouse.internal ? (
                          <img src={require('../../image/confirm.svg')} />
                        ) : (
                          <img src={require('../../image/ignor.svg')} />
                        )}
                      </td>
                      <td>{warehouse.refTypeWarehouseName}</td>
                      <td>
                        <span>{warehouse.providerName == null ? '-' : warehouse.providerName}</span>
                      </td>
                      <td>
                        <Link to={`/EditPreRecord/${warehouse.preWarehouseDocId}`} target="_blank">
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </Link>
                      </td>
                      <td>
                        <Popover
                          placement="right"
                          title={'اطلاعات بیشتر'}
                          content={
                            <div dir="rtl">
                              {
                                <>
                                  <p className="mb-0">
                                    شماره فاکتور طرف :{warehouse.refFactorNo === null ? '' : warehouse.refFactorNo}
                                  </p>
                                  <p className="mb-0">
                                    تعداد سطر :<span className="mx-1">{warehouse.rowSum}</span>
                                  </p>
                                  <p className="mb-0">
                                    جمع مقدار :<span className="mx-1">{warehouse.quantitySum}</span>
                                  </p>
                                  {warehouse.refType === 'CUSTOMER' && <p className="mb-0">نوع طرف :‌ مشتری</p>}
                                  {warehouse.refType === 'PROVIDER' && <p className="mb-0">نوع طرف :‌ فروشنده</p>}
                                </>
                              }
                            </div>
                          }
                          trigger="hover"
                        >
                          <button>
                            <img src={require('../../image/info.png')} />
                          </button>
                        </Popover>
                      </td>

                      <td>
                        <Link to={`/ShowPreRecord/${warehouse.preWarehouseDocId}`} target="_blank">
                          <img src={require('../../image/eye.svg')} alt="" />
                        </Link>
                      </td>

                      <td>
                        <button onClick={() => this.deletePreRecord(index)}>
                          <img src={require('../../image/trash.svg')} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthList}
                />
              </div>

              <Modal isOpen={this.state.modalDelete} toggle={this.deleteCancel} size="sm">
                <ModalHeader toggle={this.deleteCancel}>حذف پیش سند</ModalHeader>
                <ModalBody>
                  <p>آیا از حذف پیش سند شماره {preWarehouseDocIdNum} مطمئن هستید؟؟</p>
                </ModalBody>
                <ModalFooter>
                  <button className="confirmBtnModal" onClick={this.deleteOk}>
                    حذف پیش سند
                  </button>
                  <button className="cancelBtnModal" onClick={this.deleteCancel}>
                    لغو
                  </button>
                </ModalFooter>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PreRecord
